// Newsletter Form Handler
import { executeRecaptcha } from './recaptcha-handler.js';

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('newsletter_form');
    console.log('[Newsletter] DOMContentLoaded - form found:', !!form);

    if (!form) return;

    console.log('[Newsletter] Form action URL:', form.getAttribute('data-action'));
    console.log('[Newsletter] reCAPTCHA site key:', form.getAttribute('data-recaptcha-site-key') ? 'SET' : 'NOT SET');
    console.log('[Newsletter] grecaptcha available:', typeof grecaptcha !== 'undefined');

    form.addEventListener('submit', function(event) {
        event.preventDefault();
        console.log('[Newsletter] Form submitted');

        const feedback = document.querySelector('.js-newsletter-feedback');
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;

        // Reset UI
        feedback.style.display = 'none';
        feedback.classList.remove('bg-green-100', 'text-green-800', 'bg-red-100', 'text-red-800');
        submitButton.disabled = true;
        submitButton.textContent = 'Enviando...';

        // Execute reCAPTCHA v3 with reusable handler
        executeRecaptcha({
            form: form,
            tokenFieldId: 'g-recaptcha-response-newsletter',
            defaultAction: 'newsletter_form',
            onSuccess: () => submitNewsletterForm(form, feedback, submitButton, originalButtonText),
            onError: () => {
                showNewsletterFeedback(feedback, 'Error al procesar el formulario. Por favor, intenta de nuevo.', 'error');
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            }
        });
    });
});

function submitNewsletterForm(form, feedback, submitButton, originalButtonText) {
    // Get form data
    const formData = new FormData(form);
    const actionUrl = form.getAttribute('data-action');
    console.log('[Newsletter] submitNewsletterForm - actionUrl:', actionUrl);

    const data = {
        email: formData.get('email'),
        accept_communications: formData.get('accept_communications') ? true : false,
        'g-recaptcha-response': formData.get('g-recaptcha-response'),
        // Honeypot: este handler envía campos explícitos, así que hay que
        // incluirlo a mano para que el middleware pueda comprobarlo.
        website: formData.get('website')
    };

    console.log('[Newsletter] Sending data:', data);

    // Send request using Axios
    window.axios.post(actionUrl, data)
            .then(function(response) {
                console.log('[Newsletter] Response:', response.data);
                if (response.data.success == 0) {
                    showNewsletterFeedback(feedback, response.data.message, 'error');
                } else {
                    form.reset();
                    // Mostrar modal de confirmación
                    // Si la respuesta incluye un mensaje personalizado, usarlo
                    const customMessage = response.data.message || null;
                    showConfirmationModal(customMessage);
                }
            })
            .catch(function(error) {
                console.error('[Newsletter] Error:', error.response?.status, error.response?.data);
                let errorMessage = 'Ha ocurrido un error. Por favor, inténtalo de nuevo.';

                if (error.response) {
                    if (error.response.status === 422 && error.response.data) {
                        const response = error.response.data;
                        if (response.errors) {
                            // Get the first validation error message
                            const firstError = Object.values(response.errors).flat()[0];
                            if (firstError) errorMessage = firstError;
                        } else if (response.message) {
                            errorMessage = response.message;
                        }
                    } else if (error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                }

                showNewsletterFeedback(feedback, errorMessage, 'error');
            })
            .finally(function() {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            });
}

function showNewsletterFeedback(feedbackElement, message, type) {
    const classes = type === 'success'
        ? ['bg-green-100', 'text-green-800', 'p-4', 'rounded-lg', 'mt-4']
        : ['bg-red-100', 'text-red-800', 'p-4', 'rounded-lg', 'mt-4'];

    feedbackElement.classList.remove('bg-green-100', 'text-green-800', 'bg-red-100', 'text-red-800');
    feedbackElement.classList.add(...classes);
    feedbackElement.innerHTML = message;
    feedbackElement.style.display = 'block';
    feedbackElement.style.opacity = '1';
}
